import { render, staticRenderFns } from "./InquiryCopy.vue?vue&type=template&id=e4bfe07a"
import script from "./InquiryCopy.vue?vue&type=script&lang=js"
export * from "./InquiryCopy.vue?vue&type=script&lang=js"
import style0 from "./InquiryCopy.vue?vue&type=style&index=0&id=e4bfe07a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports